import { webKW } from "../../kw/kw";

const techData = [
     {
         id:0,
        title: "Web Development",
        caption:  `Our ${webKW} provide full stack web development services and provide applications that are scalable, fast, look good, and are useful in the real world. Whether it be business, e-commerce, portfolio, or startup, we will be glad to build a website for you.`,
        icon: "fa fa-3x fa-mail-bulk text-primary mb-4"
    },
  {
        id:1,
        title: "App Development",
        caption: "Our software development company can build stylish, dynamic, and fast apps. To build apps, we use React native, which is used by intagram, Facebook, Uber, Skype, and many more apps built with this technology.",
        icon: "fa fa-3x fa-search text-primary mb-4"
    }
]
export default techData;